'use client'

import Link from 'next/link'

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="bg-background pt-[calc(4.5rem+env(safe-area-inset-top))]">
      <div className="site-shell site-section mx-auto max-w-2xl text-center">
        <p className="site-label">Something went wrong</p>
        <h1 className="site-title mt-4">Please try again.</h1>
        <p className="site-copy mx-auto mt-4">
          This page could not load. Check your connection and retry — no payment or booking is affected.
        </p>
        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
          <button type="button" onClick={reset} className="site-button-primary">
            Retry
          </button>
          <Link href="/" className="site-button-secondary">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  )
}
